// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading[data-v-417c0f75],.loading *[data-v-417c0f75]{cursor:progress!important}.listpage-list-wrapper[data-v-417c0f75]{display:grid;grid-gap:10px;gap:10px}.rating-summary[data-v-417c0f75]{margin-bottom:15px}.dynamic-text[data-v-417c0f75]{word-break:break-word}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
